import React, { Component } from 'react';
import {appName} from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import {notify} from 'react-notify-toast';
import {Helmet} from "react-helmet";
import {Row,Col,Table,Modal} from 'react-bootstrap';
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';
import Pagination from "react-js-pagination";

import PageTitle from '../../../containers/PageTitle';
import Add from './Add';
import Edit from './Edit';

class PostVacancy extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			loginText: 'LOGIN',
			isRedirect: false,
			showAddModal: false,
			showEditModal: false,
			currentPage: 1,
			todosPerPage: 10,
			activePage:1,
			dataList: [],
			dataView: [],
			editData: [],
		}
		
		this.handleSearch = this.handleSearch.bind(this);
		this.loadData = this.loadData.bind(this);
	}
	
	componentDidMount(){
		
		this.loadData();
	}
	
	loadData(){
		this.setState({showLoader:true});
		var token = Reqst.TimeStamp();
		Reqst.axGet('vacancy/getVacancyList/'+this.state.masterId+'/'+this.state.companyId+'/'+token).then(res=>{
			if(res['data'].status=='1')
			{
				this.setState({dataList: res['data'].data, dataView: res['data'].data, showLoader:false});	
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false});	
			}
		});
	}
	
	handleSearch(e){
		try{
			var list = this.state.dataList;
			var v = e.target.value.toUpperCase();
			var l = list.filter(function(obj){
				const cname = obj.categoryname.toUpperCase();
				const ccode = obj.categorycode.toUpperCase();				
				return ((cname.indexOf(v)>-1) || (ccode.indexOf(v)>-1) );
			});
			this.setState({dataView:l});
		}
		catch(error){
			console.log(error);
		}
	}
	
	handleEdit(id,e){
		var list = this.state.dataView;
		var index = list.findIndex(function(obj){ return obj.id==id });
		var l = list[index];
		this.setState({editData: l, showEditModal: true});
	}
	
	removeValue(id,e){
		this.setState({showLoader:true});
		var token = Reqst.TimeStamp();
		Reqst.axGet('vacancy/removeVacancy/'+this.state.masterId+'/'+this.state.companyId+'/'+id+'/'+token).then(res=>{
			if(res['data'].status=='1')
			{
				var l = this.state.dataList;
				var index = l.findIndex(function(obj){
					return (obj.id==id);
				});
				l.splice(index,1);
				this.setState({dataList:l,dataView:l,  showLoader:false});
				notify.show(res['data'].msg,'success');
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false});	
			}
		});
	}
	
	handleRemoveClick(id,e){
		
		swal({title:'Confirm',text:'Do you want to Delete?',buttons:['No','Yes']}).then((willYes)=>{
			if(willYes) this.removeValue(id,e);
		});
				
	}
	
	render(){
		
		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		 const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		 const currentTodos = this.state.dataList.slice(indexOfFirstTodo, indexOfLastTodo);
		 let sno = indexOfFirstTodo + 1;
		 
		return(
			<div>
			
				<Helmet>
					<title>{appName} | Vacancy Details</title>
				</Helmet>
				
				<PageTitle title="Vacancy Details" loading={this.state.showLoader} > 
					<div className="text-right">
					{/*<button className="btn btn-primary btn-sm btn-primary_2" onClick={()=>{this.setState({showAddModal:true})}} ><i className="fa fa-plus"></i> 
						Add Group
					</button>*/}
					{Roles.Can('appointment','interview','canadd') ?
							<button className="btn btn-info btn-sm" onClick={()=>{this.setState({showAddModal:true})}} >
								<i className="fa fa-plus"></i>  Add Vacancy
						</button> : null }
						
						&nbsp;
						<button className="btn btn-info btn-sm" onClick={this.loadData} >
							<i className="fa fa-refresh"></i> 
						</button>
					</div>
				</PageTitle>				
				<Row style={{ marginBottom: 5 }} >
					
					<Col md={9} >
						<div className="text-right" >
							
							
						</div>
					</Col>
				</Row>
				<Row>
					<Col md={12} >
						<Table hover responsive className="list-table">
							<thead>
								<tr>
									<th width="60" >Sl.No</th>								
									<th>Category</th>
									<th>Total vacancies</th>
									<th>Vacancies(Male)</th>
									<th>Vacancies(Female)</th>
									<th width="80" >Manage</th>
								</tr>
							</thead>
							<tbody>
							{
								currentTodos.map((item,key)=>{
									return <tr key={key} >
										<td>{sno++}</td>									
										<td style={{textTransform : 'capitalize'}}>{item.categoryname}</td>
										<td>{item.total_vacant}</td>
										<td>{item.male_vacant}</td>
										<td align="center" >{item.female_vacant}</td>
										<td align="center" >
										{Roles.Can('appointment','interview','canedit') ?
											<button className="btn btn-sm btn-warning btn-lowpadding" onClick={this.handleEdit.bind(this,item.id)} >
												<i className="fa fa-edit"></i>
											</button> : null }
											&emsp;
										{Roles.Can('appointment','interview','candelete') ?
											<button className="btn btn-sm btn-danger btn-lowpadding" onClick={this.handleRemoveClick.bind(this,item.id)} >
												<i className="fa fa-remove"></i>
											</button> : null}
										</td>
									</tr>;
								})
							}
							</tbody>
						</Table>
					</Col>
				</Row>
				
				<Row>
					<Col md={1} >
						<select className="form-control input-sm" onChange={(e)=>{this.setState({activePage:1,currentPage:Number(1), todosPerPage: e.target.value})}} >
							<option value="10"> 10 </option>
							<option value="15"> 15 </option>
							<option value="20"> 20 </option>
							<option value="50"> 50 </option>
							<option value="100"> 100 </option>
						</select>
					</Col>
					<Col md={10} >
						 <Pagination
						  activePage={this.state.activePage}
						  itemsCountPerPage={this.state.todosPerPage}
						  totalItemsCount={(this.state.dataView).length}
						  pageRangeDisplayed={7}
						  onChange={(pN)=>{this.setState({activePage:pN, currentPage: Number(pN)})}}
						/>
					</Col>
				</Row>
				
				<Modal size="md" show={this.state.showAddModal} onHide={()=>{this.setState({showAddModal:false})}} className="right" >
					<Modal.Header closeButton >
						<Modal.Title>Add Vacancy</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Add afterFinish={this.loadData} />
					</Modal.Body>
				</Modal>
				
				<Modal size="md" show={this.state.showEditModal} onHide={()=>{this.setState({showEditModal:false})}} className="right" >
					<Modal.Header closeButton >
						<Modal.Title>Edit Vacancy</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Edit editData={this.state.editData} afterFinish={this.loadData} />
					</Modal.Body>
				</Modal>
				
			</div>
		);
	}
	
}
export default PostVacancy;